import {
  Handshake,
  Home,
  EmojiEvents,
  Category,
  Apartment,
  CalendarToday,
  Group,
  People,
  Article,
  Subscriptions,
  Message,
  AccountBalance,
  Business,
  RateReview,
  Person,
  PhotoLibrary,
  ContactSupport,
} from "@mui/icons-material";

import { Menu } from "../model/menu";

export const menus: Menu[] = [
  {
    name: "Dashboard",
    path: "/",
    icon: Home,
  },
 
  {
    name: "Awards",
    path: "/awards",
    icon: EmojiEvents, // Trophy/award icon - much better than ProductionQuantityLimits
  },
   {
    name: "Award Areas",
    path: "/awardareas",
    icon: Category, // Category icon - better represents different award categories/areas
  },
  {
    name: "Gallery",
    path: "/gallery",
    icon: PhotoLibrary, // Photo library icon for gallery - this is perfect
  },
  {
    name: "User",
    path: "/users",
    icon: People, // Multiple people icon - better for user management
  },
  {
    name: "Blog",
    path: "/blogs",
    icon: Article, // Article icon - much better than RSS feed for blog content
  },
  {
    name: "Testimonial",
    path: "/testimonials",
    icon: RateReview, // Review/rating icon for testimonials - this is perfect
  },
  {
    name: "Partners",
    path: "/partners",
    icon: Handshake, // Handshake icon for partners - this is perfect
  },
  {
    name: "Team",
    path: "/teams",
    icon: Group, // Group/team icon - this is perfect
  },
  {
    name: "Subscribers",
    path: "/subscribers",
    icon: Subscriptions, // Subscription icon - this is perfect
  },
  {
    name: "Newsletters",
    path: "/newsletters",
    icon: Article, // Article icon - better than RSS feed for newsletters
  },
  {
    name: "Messages",
    path: "/messages",
    icon: ContactSupport, // Contact support icon - better than generic message
  },
];
